import React from "react";
import UserField from "../Fields/UserField";

export default function SendEmailAction(props) {
    return (
        <UserField
            name={`actions[${props.index}].properties.users`}
            label="Send Email To"
        />
    );
}
